<template>
    <v-row class="hint-message align-center">
        <v-col cols="auto" class="d-flex" :class="iconPositionClass">
            <v-icon class="hint-icon" :color="iconColor">{{ icon }}</v-icon>
        </v-col>
        <v-col>
            <div class="hint-content">
                <div class="hint-title mb-1">{{ title }}</div>
                <div class="hint-description" v-if="descriptionHtml" v-html="description"></div>
                <div class="hint-description" v-else>{{ description }}</div>
            </div>
        </v-col>
    </v-row>
</template>

  <script>
  export default {
    name: 'HintMessage',
    props: {
      title: {
        type: String,
        required: true
      },
      icon: {
        type: String,
        required: true
      },
      iconColor: {
        type: String,
        required: true
      },
      centerIcon: {
        type: Boolean,
        default: false
      },
      description: {
        type: String,
        required: true
      },
      descriptionHtml: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      iconPositionClass () {
        return this.centerIcon ? 'align-self-center' : 'align-self-start'
      }
    }
  }
  </script>

  <style scoped>
  .hint-message {
    display: flex;
    align-items: center;
  }
  .hint-icon {
    margin-right: 0px;
    font-size: 36px;
  }
  .hint-content {
    display: flex;
    flex-direction: column;
  }
  .hint-title {
    font-weight: bold;
    font-size: 15px;
  }
  .hint-description {
    color: #777;
    font-size: 14px;
  }
  </style>
